import { useScenarioType } from "../ScenarioTypeContext"
import SaveButton from "../SaveButton"

const SaveInterventionsButton = () => {
    const {saveInterventions} = useScenarioType()

    const saveHandler = async (event) => {
        event.preventDefault()
        const res = await saveInterventions()
        if (true === res) {
            alert("Interventions save successfully")
        } else {
            alert(res)
        }
    }

    return (
        <SaveButton
            haveChanges={true}
            clickHandler={saveHandler}
        />
    )
}

export default SaveInterventionsButton